module.exports = __webpack_public_path__ + "static/img/04@2x.d3865b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/04@2x.png
// module id = 3VGh
// module chunks = 1